import "./App.css";

import {
  Route,
  BrowserRouter as Router,
  Routes,
  useNavigate,
} from "react-router-dom";

import { Login } from "./common/components/Login";
import { LostUnitsCreatePage } from "./LostUnits/LostUnitsCreate/LostUnitsCreatePage";
import { LostUnitsEditPage } from "./LostUnits/LostUnitsCreate/LostUnitsEditPage";
import { LostUnitsListPage } from "./LostUnits/LostUnitsList/LostUnitsListPage";
import { MainPage } from "./common/components/MainPage";
import { RequireAuth } from "./common/components/RequireAuth";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/Login" element={<Login />} />
        <Route
          path="/"
          element={
            <RequireAuth>
              <MainPage />
            </RequireAuth>
          }
        />
        <Route
          path="/LostUnits/Create"
          element={
            <RequireAuth>
              <LostUnitsCreatePage />
            </RequireAuth>
          }
        />
        <Route
          path="/LostUnits/Edit/:recordId"
          element={
            <RequireAuth>
              <LostUnitsEditPage />
            </RequireAuth>
          }
        />
        <Route
          path="/LostUnits/List"
          element={
            <RequireAuth>
              <LostUnitsListPage />
            </RequireAuth>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
